import type { StorefrontOrder } from "@bytebite/schemas";

export const ACCEPTANCE_ETA_OPTIONS = [15, 30, 45, 60] as const;

export function formatEtaLabel(minutes: number): string {
  return minutes === 60 ? "60+" : String(minutes);
}

export function remainingAcceptanceMs(deadlineIso: string, nowMs: number): number {
  return new Date(deadlineIso).getTime() - nowMs;
}

export function formatAcceptanceCountdown(deadlineIso: string, nowMs: number): string {
  const remaining = remainingAcceptanceMs(deadlineIso, nowMs);
  if (remaining <= 0) {
    return "0:00";
  }
  const totalSeconds = Math.ceil(remaining / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

function fulfillmentWord(order: StorefrontOrder): string {
  return order.fulfillmentType === "delivery" ? "delivery" : "pickup";
}

export function orderStatusLabel(order: StorefrontOrder): string {
  const eta =
    order.etaMinutes == null ? "" : ` · ETA ${formatEtaLabel(order.etaMinutes)} min`;
  const fulfillment = fulfillmentWord(order);
  if (
    order.orderStatus === "accepted" ||
    order.orderStatus === "preparing" ||
    order.orderStatus === "ready" ||
    order.orderStatus === "completed"
  ) {
    return `${order.orderStatus}${eta} / cash / ${fulfillment}`;
  }
  if (order.orderStatus === "cancelled") {
    if (order.cancellationReason === "acceptance_timeout") {
      return `cancelled · acceptance timeout / cash / ${fulfillment}`;
    }
    if (order.cancellationReason === "restaurant_rejected") {
      return `cancelled · rejected / cash / ${fulfillment}`;
    }
    return `cancelled / cash / ${fulfillment}`;
  }
  return `${order.orderStatus} / cash / ${fulfillment}`;
}

export function canOperatorAct(order: StorefrontOrder, nowMs: number): boolean {
  return order.orderStatus === "pending" && remainingAcceptanceMs(order.acceptanceDeadlineAt, nowMs) > 0;
}
